import ChsAttachment from 'domain/types/ChsAttachment';
import React from 'react';
import { Button } from 'react-bootstrap';

interface IImageLink {
  data: ChsAttachment;
  children?: React.ReactNode;
}

const ImageLink = (props: IImageLink) => {
  return (
    <Button
      type='button'
      onClick={() =>
        window.open(
          process.env.PUBLIC_URL + '/image/' + props.data.filenet,
          props.data.filename,
          'location=no,toolbar=no,menubar=no'
        )
      }
      variant='link'
      className='p-0 mx-2'
    >
      {props.children || props.data.filename}
    </Button>
  );
};

export default ImageLink;
